import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Box, IconButton } from '@mui/material';

const BatchSnLink = ({ row, onOpen }) => {
  if (!row?.batchSn) return '';

  const handleOpen = (event) => {
    event.stopPropagation();
    onOpen(row);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <button
        type="button"
        onClick={handleOpen}
        style={{
          padding: 0,
          border: 0,
          background: 'transparent',
          color: '#0076f8',
          cursor: 'pointer',
          textDecoration: 'underline',
          font: 'inherit',
        }}
      >
        {row.batchSn}
      </button>
      <IconButton
        size="small"
        sx={{
          color: '#0076f8',
          backgroundColor: 'transparent',
          '&:hover': { backgroundColor: 'transparent' },
        }}
        onClick={handleOpen}
      >
        <ArrowOutwardIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default BatchSnLink;
